import React from "react";
import { useSelector } from "react-redux";

export default function ErrorMessage() {
  const errorMessage = useSelector((state) => state.errorMessage);
  return (
    <div
      style={{
        position: "absolute",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "10%",
        left: "0",
        right: "0",
        textAlign: "center",
        color: "red",
      }}
    >
      {errorMessage.message !== "" ? errorMessage : ""}
    </div>
  );
}
